// extracted by mini-css-extract-plugin
export default {"editButtonText":"CartEditLink_editButtonText__kIXF3","editIcon":"CartEditLink_editIcon__hlNnb"};